/* ===== AROMAZUR v32 — zoom plein ecran sur les fiches produit =====
   La visionneuse existait uniquement sur la page d'accueil (dans les bulles).
   Ce fichier la reconstruit sur /products/ : clic sur l'image principale ou
   sur une vignette, navigation clavier, molette, glisser-deposer, pincement.
   Les styles .lightbox-* sont deja dans le theme, on les reutilise tels quels. */
(function(){
  var imgs=[], idx=0, sc=1, tx=0, ty=0, drag=false, sx=0, sy=0, ov=null, wrap=null, img=null;

  function pleineTaille(u){
    /* Shopify sert la meme image a n'importe quelle largeur : on demande la plus grande */
    return String(u||'').replace(/([?&])width=\d+/, '$1width=1800');
  }

  function liste(){
    var t=[].slice.call(document.querySelectorAll('.pp-thumb'));
    if(t.length){
      return t.map(function(b){
        var m=(b.getAttribute('onclick')||'').match(/azSetMainImg\('([^']+)'/);
        if(m) return pleineTaille(m[1]);
        var i=b.querySelector('img'); return i?pleineTaille(i.src):'';
      }).filter(Boolean);
    }
    var p=document.getElementById('ppMainImg');
    return p?[pleineTaille(p.src)]:[];
  }

  function construire(){
    ov=document.createElement('div');
    ov.className='lightbox-ov'; ov.id='azLbOv';
    ov.innerHTML=
      '<button class="lightbox-close" type="button" aria-label="Fermer">&times;</button>'+
      '<div class="lightbox-counter"></div>'+
      '<button class="lightbox-nav lightbox-prev" type="button" aria-label="Image précédente">&lsaquo;</button>'+
      '<div class="lightbox-img-wrap"><img class="lightbox-img" alt="" draggable="false"></div>'+
      '<button class="lightbox-nav lightbox-next" type="button" aria-label="Image suivante">&rsaquo;</button>'+
      '<div class="lightbox-zoom-controls">'+
        '<button class="lightbox-zoom-btn" type="button" data-z="-1" aria-label="Réduire">&minus;</button>'+
        '<button class="lightbox-zoom-btn" type="button" data-z="0" aria-label="Réinitialiser">&#8635;</button>'+
        '<button class="lightbox-zoom-btn" type="button" data-z="1" aria-label="Agrandir">+</button>'+
      '</div>'+
      '<div class="lightbox-hint">Cliquez pour zoomer · molette pour ajuster · glissez pour déplacer</div>';
    document.body.appendChild(ov);
    wrap=ov.querySelector('.lightbox-img-wrap');
    img=ov.querySelector('.lightbox-img');

    ov.querySelector('.lightbox-close').addEventListener('click',fermer);
    ov.querySelector('.lightbox-prev').addEventListener('click',function(e){e.stopPropagation();nav(-1);});
    ov.querySelector('.lightbox-next').addEventListener('click',function(e){e.stopPropagation();nav(1);});
    ov.querySelectorAll('.lightbox-zoom-btn').forEach(function(b){
      b.addEventListener('click',function(e){
        e.stopPropagation();
        var z=parseInt(b.getAttribute('data-z'),10);
        if(z===0) reset(); else zoom(z);
      });
    });
    /* clic sur le fond noir = fermeture */
    ov.addEventListener('click',function(e){ if(e.target===ov) fermer(); });

    wrap.addEventListener('click',function(e){
      if(drag) return;
      if(sc===1){
        sc=2;
        var r=wrap.getBoundingClientRect();
        tx=(r.width/2-(e.clientX-r.left))*0.5;
        ty=(r.height/2-(e.clientY-r.top))*0.5;
        applique();
      } else reset();
    });
    wrap.addEventListener('wheel',function(e){ e.preventDefault(); zoom(e.deltaY<0?1:-1); },{passive:false});
    wrap.addEventListener('mousedown',function(e){ if(sc>1){ drag=true; sx=e.clientX-tx; sy=e.clientY-ty; e.preventDefault(); } });
    window.addEventListener('mousemove',function(e){ if(drag){ tx=e.clientX-sx; ty=e.clientY-sy; applique(); } });
    window.addEventListener('mouseup',function(){ setTimeout(function(){drag=false;},50); });
    wrap.addEventListener('touchstart',function(e){ if(sc>1&&e.touches.length===1){ drag=true; sx=e.touches[0].clientX-tx; sy=e.touches[0].clientY-ty; } },{passive:true});
    wrap.addEventListener('touchmove',function(e){ if(drag&&e.touches.length===1){ tx=e.touches[0].clientX-sx; ty=e.touches[0].clientY-sy; applique(); } },{passive:true});
    wrap.addEventListener('touchend',function(){ setTimeout(function(){drag=false;},50); });

    document.addEventListener('keydown',function(e){
      if(!ov.classList.contains('open')) return;
      if(e.key==='Escape') fermer();
      else if(e.key==='ArrowLeft') nav(-1);
      else if(e.key==='ArrowRight') nav(1);
      else if(e.key==='+'||e.key==='=') zoom(1);
      else if(e.key==='-') zoom(-1);
    });
  }

  function applique(){
    img.style.transform='translate('+tx+'px,'+ty+'px) scale('+sc+')';
    wrap.classList.toggle('zoomed', sc>1);
  }
  function reset(){ sc=1; tx=0; ty=0; applique(); }
  function zoom(d){ sc=Math.min(4,Math.max(1,sc+d*0.5)); if(sc===1){tx=0;ty=0;} applique(); }

  function montre(){
    img.src=imgs[idx];
    ov.querySelector('.lightbox-counter').textContent=imgs.length>1?(idx+1)+' / '+imgs.length:'';
    var multi=imgs.length>1;
    ov.querySelector('.lightbox-prev').style.display=multi?'':'none';
    ov.querySelector('.lightbox-next').style.display=multi?'':'none';
    reset();
  }
  function nav(d){ idx=(idx+d+imgs.length)%imgs.length; montre(); }

  function ouvre(depart){
    imgs=liste();
    if(!imgs.length) return;
    idx=Math.max(0, imgs.indexOf(depart));
    if(idx<0) idx=0;
    montre();
    ov.classList.add('open');
    document.body.style.overflow='hidden';
  }
  function fermer(){
    ov.classList.remove('open');
    document.body.style.overflow='';        /* la version d'accueil oubliait de le rendre */
    reset();
  }

  function boot(){
    var principale=document.getElementById('ppMainImg');
    if(!principale) return;                 /* on n'est pas sur une fiche produit */
    construire();

    principale.style.cursor='zoom-in';
    principale.setAttribute('title','Cliquez pour agrandir');
    principale.addEventListener('click',function(){ ouvre(pleineTaille(principale.src)); });

    /* une loupe discrete sur le coin de l'image, pour que l'affordance soit visible */
    var cadre=principale.parentNode;
    if(cadre && !cadre.querySelector('.pp-zoom-ic')){
      cadre.style.position=cadre.style.position||'relative';
      var b=document.createElement('button');
      b.type='button'; b.className='pp-zoom-ic'; b.setAttribute('aria-label','Agrandir l’image');
      b.innerHTML='<svg viewBox="0 0 24 24" width="17" height="17" fill="none" stroke="currentColor" stroke-width="1.7">'+
                  '<circle cx="11" cy="11" r="7"/><path d="M20 20l-4.3-4.3M11 8v6M8 11h6"/></svg>';
      b.addEventListener('click',function(e){ e.stopPropagation(); ouvre(pleineTaille(principale.src)); });
      cadre.appendChild(b);
    }

    /* double-clic sur une vignette : on l'affiche puis on ouvre directement dessus */
    document.querySelectorAll('.pp-thumb').forEach(function(t){
      t.addEventListener('dblclick',function(){ ouvre(pleineTaille(principale.src)); });
    });
  }

  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',boot); else boot();
})();
